var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-divider',{staticClass:"mt-4"}),_c('v-card-title',[_c('h3',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.descTitle))])]),_c('v-card-text',{staticClass:"formatText",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }